/***
*
*   HOME NAV
*   Navigation used on the main external website. Renders a dashboard link
*   if the user is signed in, or a sign up link if they are not
*
**********/

import { Fragment, useContext } from 'react';
import { AuthContext, useTranslation, Logo, Link, Content, ClassHelper } from 'components/lib';
import Style from './home.module.scss';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { useNavigate } from 'react-router-dom';

export function HomeNav(props) {

    // context
    const context = useContext(AuthContext);
    const { t } = useTranslation();

    const css = ClassHelper(Style, {

        wrapper: true,
        color: !props.transparent,
        transparent: props.transparent

    });

    const navigate = useNavigate();

    return (
        <section className={css}>
            <Content>

                <Logo className={Style.logo} />
                <nav className={Style.nav}>
                    {!props?.hideNavItems?.contact && (
                        <Link url='/contact' text={t('global.home.sales')} className={Style.contact} color='dark' />
                    )}
                    {context.user?.token ?
                        // <Button color='blue' small goto='/dashboard' text='Dashboard' className={Style.button} />
                        <AivagamButton
                            id="dashboardButton"
                            onClick={() => {
                                navigate('/dashboard')
                            }}
                            buttonText={t('global.home.dashboard')}
                            classStyles={{
                                fontSize: "1em",
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                padding: '0.75em 1.5em'
                            }}
                        />
                        :
                        <Fragment>
                            {!props?.hideNavItems?.signin && (
                                <Link url='/signin' text={t('global.home.signIn')} className={Style.link} color='dark' />
                            )}
                            {!props?.hideNavItems?.signup && (
                                <AivagamButton
                                    id="signupButton"
                                    onClick={() => {
                                        navigate('/signup')
                                    }}
                                    buttonText={t('global.home.signUp')}
                                    classStyles={{
                                        fontSize: "1em",
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                        padding: '0.75em 1.5em'
                                    }}
                                />
                            )}
                        </Fragment>
                    }
                </nav>
            </Content>
        </section>
    );
}